import { createComponent } from '@carvana/merch-components';

export const ToolTipWrapper = createComponent('span', {
  className: 'relative inline-flex cursor-pointer'
});
